import { render } from "./InputUser.vue?vue&type=template&id=28fcced4&scoped=true"
import script from "./InputUser.vue?vue&type=script&lang=ts"
export * from "./InputUser.vue?vue&type=script&lang=ts"

import "./InputUser.vue?vue&type=style&index=0&id=28fcced4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28fcced4"

export default script